import { useEffect, useRef, useState } from "react";

// Booking engine ufficiale Octorate.
// NOTA TECNICA: form.js inizializza il widget sull'evento window "load".
// In una SPA quell'evento è già scattato quando il componente monta,
// quindi chiamiamo manualmente octorate.octobook.Widget.show() dopo il caricamento.
const OCTORATE_SRC = "https://resx.octorate.com/octobook/resources/widget/js/form.js";
const OCTORATE_SITEKEY = "309f39f0021010b6ef47b875b12c34ea";
const CONTAINER_ID = "octorate-widget-container";
const FALLBACK_URL = `https://book.octorate.com/octobook/site/widget/form.xhtml?sitekey=${OCTORATE_SITEKEY}`;

export default function OctorateBookingEngine() {
  const [status, setStatus] = useState("loading"); // loading | ready | error
  const started = useRef(false);

  useEffect(() => {
    if (started.current || window.__octorateStarted) { setStatus("ready"); return; }
    started.current = true;
    window.__octorateStarted = true;

    const initWidget = () => {
      if (window.__octorateShown) return;
      const c = document.getElementById(CONTAINER_ID);
      // se il widget si è già auto-inizializzato, non chiamare show() (eviterebbe un doppio caricamento di jQuery)
      if (c && c.textContent.trim().length > 0) { window.__octorateShown = true; return; }
      try {
        // eslint-disable-next-line no-undef
        if (window.octorate?.octobook?.Widget?.show) {
          window.__octorateShown = true;
          window.octorate.octobook.Widget.show();
          console.log("[octorate] widget initialized (show called)");
        }
      } catch (e) {
        console.error("[octorate] init error", e);
      }
    };

    const container = document.getElementById(CONTAINER_ID);

    const check = () => {
      const c = document.getElementById(CONTAINER_ID);
      if (c && (c.querySelector(".octobook, iframe, input, form")) && c.textContent.trim().length > 0) {
        setStatus("ready");
        return true;
      }
      return false;
    };

    // Se lo script è già presente (navigazione client-side), reinizializza soltanto.
    if (window.octorate?.octobook?.Widget) {
      initWidget();
    } else if (!document.querySelector('script[data-octorate="true"]')) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = OCTORATE_SRC;
      script.async = true;
      script.setAttribute("data-sitekey", OCTORATE_SITEKEY);
      script.setAttribute("data-container", CONTAINER_ID);
      script.setAttribute("data-octorate", "true");
      script.onload = () => { console.log("[octorate] script loaded"); setTimeout(initWidget, 500); };
      script.onerror = () => { console.error("[octorate] script failed to load"); setStatus("error"); };
      document.body.appendChild(script);
      console.log("[octorate] script added to DOM");
    } else {
      initWidget();
    }

    const iv = setInterval(() => { if (check()) clearInterval(iv); }, 700);
    const to = setTimeout(() => {
      clearInterval(iv);
      // se dopo 12s non c'è contenuto e nessun global, mostra fallback
      if (!check()) {
        if (!window.octorate?.octobook?.Widget) setStatus("error");
        else setStatus("ready");
      }
    }, 12000);

    return () => { clearInterval(iv); clearTimeout(to); };
  }, []);

  return (
    <div className="w-full">
      {status === "loading" && (
        <div className="rounded-2xl border border-brand-ivory bg-white p-10 text-center text-brand-brown" data-testid="octorate-loading">
          Caricamento disponibilità…
        </div>
      )}

      {status === "error" && (
        <div className="rounded-2xl border border-brand-ivory bg-white p-8 text-center" data-testid="octorate-error">
          <p className="text-brand-brown">Il motore di prenotazione non è momentaneamente disponibile.</p>
          <a href={FALLBACK_URL} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex bg-brand-olive text-white hover:bg-brand-black transition-colors rounded-full px-7 py-3 font-medium">
            Apri il sistema di prenotazione
          </a>
        </div>
      )}

      {/* Contenitore del widget: sempre presente, mai display:none o height:0 */}
      <div
        id={CONTAINER_ID}
        data-testid="octorate-container"
        className="octorate-widget w-full min-h-[80px]"
        style={{ display: status === "error" ? "none" : "block" }}
      />

      <div className="mt-4">
        <a href={FALLBACK_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-brand-olive underline underline-offset-4" data-testid="octorate-open-link">
          Apri il sistema di prenotazione in una nuova scheda
        </a>
      </div>
    </div>
  );
}
